import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { CauseSection } from './components/CauseSection';
import { MethodSection } from './components/MethodSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { IncludesSection } from './components/IncludesSection';
import { ValueSection } from './components/ValueSection';
import { PurchaseSection } from './components/PurchaseSection';
import { ForWhomSection } from './components/ForWhomSection';
import { FAQSection } from './components/FAQSection';
import { EmotionalClose } from './components/EmotionalClose';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-warm-white font-sans selection:bg-sky/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <AgitationSection data-id="element-3" />
      <CauseSection data-id="element-4" />
      <MethodSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <IncludesSection data-id="element-7" />
      <ValueSection data-id="element-8" />
      <PurchaseSection data-id="element-9" />
      <ForWhomSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <EmotionalClose data-id="element-12" />

      {/* Final CTA duplicate of Purchase Section is handled by scrolling to #compra from all buttons */}
      <div className="bg-navy-dark py-16 text-center px-4" data-id="element-13">
        <h2 className="text-3xl font-bold text-white mb-8" data-id="element-14">
          ¿Lista para empezar esta misma noche?
        </h2>
        <a href="#compra" className="inline-block bg-gold hover:bg-gold-light text-navy text-xl font-bold py-4 px-10 rounded-full shadow-premium transition-all transform hover:scale-105" data-id="element-15">
          VER OPCIONES DE ACCESO
        </a>
      </div>

      <FooterSection data-id="element-16" />
      <SocialProofPopup data-id="element-17" />
    </div>;
}